import React from "react";

import styled from "styled-components";

export const BuiltByMeContainer = styled.div`
	z-index: 100000;
	position: fixed;
	bottom: 0px;
	left: 50%;
	transform: translateX(-50%);
	width: 100%;
	padding: 5px 20px;
	background-color: white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-wrap: wrap;
	gap: 5px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: solid 1px #333333;

	@media(min-width:  700px) {
		flex-direction: row;
		gap: 50px

	}
`

export const BuiltByMeText = styled.h2`
	font-size: 1.2rem;
	text-align: center;
	margin: 0;
	z-index: 1;
	& a {
		text-decoration: none;
	}
`

const BuiltByMe = () => {
	
	return (
		<BuiltByMeContainer>
			<BuiltByMeText>Developed by <a href='https://mattvero.com' target="_blank" rel="noreferrer" >Matt Vero!</a> </BuiltByMeText>
			<BuiltByMeText>Full code: <a href='https://github.com/matthewvero/yelp-camp-react' target="_blank" rel="noreferrer" >GitHub/yelp-camp-react</a></BuiltByMeText>
		</BuiltByMeContainer>
	)
};

export default BuiltByMe;
